import request from '@/utils/request'

interface MetisResponse<DataType> {
  errcode?: string;
  code?: string;
  data: DataType;
  result?: DataType;
  message: string;
  status: 'ok' | '200' | 'error';
}

const get = async (url: string) => {
  const res: any = await request.get(url)
  return res.data || res.result
}

const post = async <ResponseData, Params = any>(
  url: string,
  payload: Params
) => {
  const { data } = await request.post<MetisResponse<ResponseData>>(
    url,
    payload
  )
  return data
}

/**
 * 登出
 */
export const logout = () => get('/api/login/logout')

/**
 * 爬虫网站登出
 */
export const spiderLogout = () => get('/api/spider/login/signout')

export interface Account {
  id: number;
  companyName: string;
  cityName: string;
  userName: string;
}

/**
 * 获取登录人经纪公司列表
 */
export const getManageAccount = () =>
  get(
    '/api/login/findManageAccountBindRelation'
  )

/**
 * 伪登录
 * @param data
 */
export const changeAccount = (data: {
  changeAccountId: number;
  masterAccountId: number;
}) => post<{ url?: string }>('/api/login/changeManagementAccount', data)

/**
 * 未读消息数量统计
 */
export const getUnreadMessageCount = () =>
  get('/api/message/queryMessageCount')

/**
 * 全局设置
 */
export const getGlobalConfig = () =>
  get('/api/getThemeInfoAndComVersion')

/**
 * 获取门店日报微信二维码
 */
export const getWechatKanBanSenceQrCode = () => get('/api/wechat/kanban/getSenceQrCode')

/**
 * 平台协议
 */
export const getAgreement = () =>
  get('/api/enterpriseAccount/agreement')

/**
 * 同意协议
 * @returns
 */
export const postAgreement = () => post<{ url?: string }>('/api/enterpriseAccount/renewAgreement', {})

// 经纪人商机协议
export const getNoAgreeAuthorization = () => get('/message/getNoAgreeAuthorization')
// 经纪人商机协议授权
export const agreeAuthorization = () => post('/message/agreeAuthorization', {})

// 标记消息已读
export const addReadTimes = (data: { id: string}) => post('/message/addReadTimes', data)
